/* Product tour -- 6 steps. Task-only focus. Matches restricted visibility:
 * home, hr (self-service), chat, tasks -- nothing else. */
export default {
  role: "PRODUCT",
  steps: [
    {
      id: "prod-welcome",
      route: "/",
      selector: '[data-tour-id="topbar-profile"]',
      titleKey: "tour.prod.welcome.title", titleFallback: "Welcome to Sharda, {name}!",
      bodyKey: "tour.prod.welcome.body", bodyFallback: "Quick 60-second tour of the surface you'll use every day. Skip anytime.",
      side: "bottom",
    },
    {
      id: "prod-punch",
      route: "/",
      selector: '[data-tour-id="punch-card"]',
      titleKey: "tour.prod.punch.title", titleFallback: "Mark your attendance",
      bodyKey: "tour.prod.punch.body", bodyFallback: "One tap to punch in. Your day's time-in/out lives right here on the home dashboard.",
      side: "bottom",
    },
    {
      id: "prod-tasks",
      route: "/tasks",
      selector: '[data-tour-id="my-tasks-page"]',
      titleKey: "tour.prod.tasks.title", titleFallback: "Your tasks",
      bodyKey: "tour.prod.tasks.body", bodyFallback: "Create, assign and track work. Use the +New task button and filter chips at the top to slice by state or team.",
      side: "top",
    },
    {
      id: "prod-chat",
      route: "/chat",
      selector: '[data-tour-id="chat-page"]',
      titleKey: "tour.prod.chat.title", titleFallback: "Team chat",
      bodyKey: "tour.prod.chat.body", bodyFallback: "1:1 and group conversations with the rest of Sharda. Attach files, mention people, catch up on the day.",
      side: "top",
    },
    {
      id: "prod-me",
      route: "/me",
      selector: '[data-tour-id="me-dashboard"]',
      titleKey: "tour.prod.me.title", titleFallback: "My workspace",
      bodyKey: "tour.prod.me.body", bodyFallback: "Profile, leaves, documents, timesheet and any onboarding checklist -- everything self-service lives at /me.",
      side: "top",
    },
    {
      id: "prod-replay",
      route: "/",
      selector: '[data-tour-id="tour-button"]',
      titleKey: "tour.prod.replay.title", titleFallback: "Replay any time",
      bodyKey: "tour.prod.replay.body", bodyFallback: "This header button re-launches the tour if you need a refresher later.",
      side: "bottom",
    },
  ],
};
